import { render, staticRenderFns } from "./StaticMalwareScan.vue?vue&type=template&id=20d4728a&scoped=true&"
import script from "./StaticMalwareScan.vue?vue&type=script&lang=js&"
export * from "./StaticMalwareScan.vue?vue&type=script&lang=js&"
import style0 from "./StaticMalwareScan.vue?vue&type=style&index=0&id=20d4728a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4728a",
  null
  
)

export default component.exports